module.exports = __webpack_public_path__ + "img/phhero_img2.f87065bb.png";